import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type BeneficiaryWorkflowRunsFetchFailedAction = {
	type: 'BENEFICIARY_WORKFLOW_RUNS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): BeneficiaryWorkflowRunsFetchFailedAction => ({
	type: 'BENEFICIARY_WORKFLOW_RUNS_FETCH_FAILED',
	payload,
});
